import React, {ReactElement, ReactNode} from 'react';

interface Props {
  assistiveMessage?: ReactNode;
}

const AssistiveText = ({assistiveMessage = ''}: Props): ReactElement | null =>
  assistiveMessage ? <div className="field__assistiveText">{assistiveMessage}</div> : null;

export default AssistiveText;
